<template>
  <el-checkbox-group
    v-model="comVal"
    v-bind="$attrs"
    v-on="$listeners"
    @change="change"
  >
    <el-checkbox
      v-for="item in options"
      :key="item.id"
      :label="item.id"
    >{{ item.text }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<style lang="scss"></style>

<script>
export default {

  components: {},
  props: {
    options: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },

    value: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      comVal: null
    }
  },

  watch: {
    value: {
      handler(newVal) {
        if (this.$data.comVal !== newVal) {
          this.$data.comVal = newVal
        }
      },
      deep: false
    }
  },

  created() {
    this.$data.comVal = this.value
  },

  methods: {
    change() {
      if (this.$data.comVal !== this.value) {
        this.$emit('input', this.$data.comVal)
      }
    }
  }
}
</script>
